export class ImageProcessor {
  static async analyzeImage(imageDataUrl, sensitivity = 65) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          
          const maxDim = 800;
          let width = img.width;
          let height = img.height;
          
          if (width > maxDim || height > maxDim) {
            if (width > height) {
              height = Math.round((height * maxDim) / width);
              width = maxDim;
            } else {
              width = Math.round((width * maxDim) / height);
              height = maxDim;
            }
          }

          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);

          const imgData = ctx.getImageData(0, 0, width, height);
          const data = imgData.data;
          
          const threshold = Math.round(255 - (sensitivity * 2.1));
          let crackPixels = 0;
          const totalPixels = width * height;
          
          const gridRows = 10;
          const gridCols = 10;
          const cellW = Math.floor(width / gridCols);
          const cellH = Math.floor(height / gridRows);
          const gridCounts = Array.from({ length: gridRows }, () => Array(gridCols).fill(0));

          // اسکن و تبدیل به خاکستری و شناسایی نقاط تیره (شکاف‌ها)
          for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
              const idx = (y * width + x) * 4;
              const r = data[idx];
              const g = data[idx + 1];
              const b = data[idx + 2];
              
              // روشنایی نسبی
              const gray = 0.299 * r + 0.587 * g + 0.114 * b;
              
              if (gray < threshold) {
                crackPixels++;
                const gx = Math.min(Math.floor(x / cellW), gridCols - 1);
                const gy = Math.min(Math.floor(y / cellH), gridRows - 1);
                gridCounts[gy][gx]++;
                
                // هایلایت ترک با رنگ سرخ/کهربایی در تصویر خروجی
                data[idx] = 245;     // R
                data[idx + 1] = 75;  // G
                data[idx + 2] = 50;  // B
              }
            }
          }

          ctx.putImageData(imgData, 0, 0);

          // تشکیل کادرهای هوشمند (Bounding Boxes) دور مناطق بحرانی
          const boxes = [];
          const cellThreshold = (cellW * cellH) * 0.05;

          ctx.lineWidth = 2;
          ctx.strokeStyle = '#f59e0b';
          ctx.fillStyle = 'rgba(245, 158, 11, 0.15)';

          for (let r = 0; r < gridRows; r++) {
            for (let c = 0; c < gridCols; c++) {
              if (gridCounts[r][c] > cellThreshold) {
                const bx = c * cellW;
                const by = r * cellH;
                boxes.push({ x: bx, y: by, w: cellW, h: cellH });
                
                ctx.strokeRect(bx, by, cellW, cellH);
                ctx.fillRect(bx, by, cellW, cellH);
              }
            }
          }

          const damageRatio = ((crackPixels / totalPixels) * 100).toFixed(2);
          let severity = 'خفیف (طبیعی)';
          let severityColor = 'text-emerald-400';

          if (damageRatio > 2.5) {
            severity = 'بحرانی (نیازمند بهسازی)';
            severityColor = 'text-rose-400';
          } else if (damageRatio > 0.8) {
            severity = 'متوسط (هشدار ترک‌خوردگی)';
            severityColor = 'text-amber-400';
          }

          resolve({
            processedCanvasUrl: canvas.toDataURL('image/jpeg', 0.9),
            damageRatio: parseFloat(damageRatio),
            crackPixels,
            totalPixels,
            detectedClusters: boxes.length,
            severity,
            severityColor,
            analyzedAt: new Date().toLocaleDateString('fa-IR')
          });
        } catch (e) {
          reject(e);
        }
      };
      img.onerror = reject;
      img.src = imageDataUrl;
    });
  }
}
